import { SnackbarProvider } from "notistack";
import React from "react";
import { Route, Switch } from "react-router-dom";
import CampaignPage from "./CampaignPage";
import { Fonts, FontFamilies, FontColors } from "theme/fontConfig";

export const FundraisingLink = () => (
  <SnackbarProvider
    maxSnack={1}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
    autoHideDuration={4000}
    style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
  >
    <Switch>
      <Route path="/fundraising/:slug" component={CampaignPage} />
      <Route path="/fundraising" render={() => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", fontFamily: FontFamilies.SansSerif, color: FontColors.Gray555555 }}>
          <p>Campaign not found. Please use a valid campaign link.</p>
        </div>
      )} />
    </Switch>
  </SnackbarProvider>
);
